import classNames from 'classnames';

import type { PersonalizedSkeletonProps } from '../personalizedSkeletonTypes';
import classes from './TeaserPersonalizedSkeleton.module.scss';
import shared from './personalizedSkeletonShared.module.scss';

/** Fixed layout — do not derive slots from blok (Storyblok/hydration data is unstable during loading). */
const TeaserPersonalizedSkeleton: React.FC<PersonalizedSkeletonProps> = ({ blok }) => {
  if (blok.component !== 'component_teaser') {
    return null;
  }

  return (
    <div className={classes.root} data-testid="personalized-content-skeleton-teaser">
      <div className={classes.content}>
        <div className={classNames(shared.shimmer, shared.headlineBar)} />

        <div className={shared.paragraphLines}>
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className={classNames(shared.shimmer, shared.lineBar)} />
          ))}
        </div>

        <div className={classNames(shared.shimmer, classes.buttonBar)} />
      </div>

      <div className={classNames(shared.shimmer, classes.imageBar)} />
    </div>
  );
};

export default TeaserPersonalizedSkeleton;
